var helpersUtils = {
  convertFromCents: function convertFromCents(value) {
    return value / 100;
  },
  generateUniqueId: function generateUniqueId() {
    return Math.random().toString(36).substring(2, 16);
  },
  generateUniqueNumber: function generateUniqueNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
};
export default helpersUtils;